var map = {
	"./404.svg": 936,
	"./Categories.png": 692,
	"./Edit-menu.svg": 937,
	"./Egg.svg": 938,
	"./Emaier-Header.png": 939,
	"./Qr-4.png": 940,
	"./_duplicate.svg": 941,
	"./_overview.svg": 942,
	"./add-white.svg": 943,
	"./alert.svg": 944,
	"./all_category.svg": 945,
	"./archive.svg": 946,
	"./armchair.svg": 947,
	"./arrow-circle-right.svg": 948,
	"./arrow-left-circle.svg": 949,
	"./arrow-right-circle.svg": 950,
	"./arrow-right.svg": 351,
	"./asc-up-white.svg": 951,
	"./asc.png": 952,
	"./asc.svg": 953,
	"./back-arrow.svg": 954,
	"./barcode-icon.svg": 955,
	"./beverages.svg": 956,
	"./blue-edit-pen.svg": 957,
	"./blue-eye.svg": 958,
	"./box-office.svg": 959,
	"./broken-seat.jpg": 960,
	"./calendar_list.svg": 961,
	"./chevron-down.svg": 962,
	"./chevron-left.svg": 963,
	"./cinema-mamagement-sidebar.svg": 964,
	"./claendar.svg": 302,
	"./clock-1.svg": 965,
	"./clock.svg": 966,
	"./close-button.svg": 697,
	"./close-white.svg": 703,
	"./close-x.svg": 295,
	"./collapse-up.svg": 967,
	"./collapse.svg": 968,
	"./connection-lost.svg": 301,
	"./copy.svg": 969,
	"./copy_image_icon.png": 970,
	"./delete-red-light.svg": 971,
	"./delete-red.svg": 704,
	"./delete.svg": 680,
	"./deliver-icon.svg": 972,
	"./desc-down-white.svg": 973,
	"./desc.svg": 974,
	"./distributors-sidebar.svg": 975,
	"./download.svg": 976,
	"./dragndrop.svg": 977,
	"./dragndrop2.svg": 978,
	"./duplicate.svg": 979,
	"./duplicateScreen.svg": 980,
	"./e-wallet-icon-black.svg": 981,
	"./edit-pen-blue.svg": 982,
	"./edit-pen-white.svg": 983,
	"./edit-pen.svg": 984,
	"./edit.svg": 985,
	"./email.png": 986,
	"./empty-image.svg": 987,
	"./excel.svg": 988,
	"./external-link.svg": 989,
	"./eye.svg": 990,
	"./filter-icon.svg": 352,
	"./flag.svg": 991,
	"./fnb-beverages.svg": 992,
	"./fnb-brownie.svg": 993,
	"./fnb-combo.svg": 994,
	"./fnb-desert.svg": 995,
	"./fnb-eatables.svg": 996,
	"./fnb-make-your-combo.svg": 997,
	"./fnb-popcorn.svg": 998,
	"./fnbtransactionIcon.svg": 999,
	"./fullscreen-icon.svg": 705,
	"./funnel.svg": 1000,
	"./globe.svg": 1001,
	"./green-tick.svg": 1002,
	"./grid-view.svg": 1003,
	"./hide-password.svg": 353,
	"./home-icon.svg": 1004,
	"./home.svg": 1005,
	"./icon-black-play.svg": 1006,
	"./icon-dot.svg": 1007,
	"./icon-fnb.svg": 1008,
	"./icon-marketing.svg": 1009,
	"./icon-no-seat.png": 1010,
	"./icon-no-seat.svg": 1011,
	"./icon-option.svg": 1012,
	"./icon-poin-of-sale.svg": 1013,
	"./icon-recliner.svg": 1014,
	"./icon-report.svg": 1015,
	"./icon-sofa-dark-1.svg": 1016,
	"./icon-sofa-dark.png": 1017,
	"./icon-sofa-dark.svg": 1018,
	"./icon-sofa.svg": 1019,
	"./importfile.svg": 1020,
	"./info.svg": 699,
	"./info2.svg": 1021,
	"./keyboard-icon.svg": 1022,
	"./kitchen_display.svg": 1023,
	"./language-icon.svg": 296,
	"./left-caret.svg": 1024,
	"./link.svg": 1025,
	"./list-view.svg": 1026,
	"./loading.svg": 354,
	"./lock.svg": 1027,
	"./login-password.png": 355,
	"./login-user.png": 356,
	"./logout.svg": 706,
	"./masters-sidebar.svg": 1028,
	"./merchandise.svg": 1029,
	"./minus.svg": 1030,
	"./movie-pass-svg.svg": 685,
	"./movie-rolling.svg": 1031,
	"./mulitSchedule.svg": 1032,
	"./multicurrency.svg": 1033,
	"./multifnb.svg": 1034,
	"./nav-plus.svg": 1035,
	"./no-image.svg": 1036,
	"./no-schedule.svg": 131,
	"./non-veg-mark.png": 1037,
	"./non-veg-mark.svg": 1038,
	"./notification.svg": 1039,
	"./open-link-blue.svg": 1040,
	"./openPlanned.svg": 1041,
	"./overview.svg": 1042,
	"./overview2.svg": 1043,
	"./pdf-icon.svg": 1044,
	"./pdf.svg": 1045,
	"./pickup-ticket-icon.svg": 1046,
	"./pickupfnb.svg": 1047,
	"./play.svg": 1048,
	"./plus.svg": 1049,
	"./pointofsale-1.svg": 1050,
	"./pointofsale-2.svg": 1051,
	"./pointofsale.png": 1052,
	"./portfolio.svg": 1053,
	"./pos-fnb-no-itmes.svg": 693,
	"./pos-refresh.svg": 1054,
	"./primary/chevron-down.svg": 1055,
	"./primary/download.svg": 1056,
	"./primary/edit.svg": 1057,
	"./primary/filter.svg": 1058,
	"./primary/printer.svg": 1059,
	"./print-icon.svg": 1060,
	"./print.svg": 1061,
	"./question.svg": 1062,
	"./question1.svg": 1063,
	"./question2.svg": 707,
	"./question3.svg": 1064,
	"./recliner-1.svg": 1065,
	"./recliner.png": 1066,
	"./refund-icon.svg": 1067,
	"./reload-icon-pos.svg": 1068,
	"./reload-icon.svg": 1069,
	"./restore.svg": 1070,
	"./right-caret.svg": 1071,
	"./role-management-sidebar.svg": 1072,
	"./save.svg": 1073,
	"./schedule-icon.svg": 1074,
	"./school-calendar.svg": 1075,
	"./search-global-white.svg": 1076,
	"./search-global.svg": 1077,
	"./search.svg": 1078,
	"./searchIcon.svg": 1079,
	"./seat-icon-2.svg": 1080,
	"./seat-icon.svg": 1081,
	"./seat-icons/3-wheelChair.png": 1082,
	"./seat-icons/block_seat_new.png": 1083,
	"./seat-icons/broken-seat-1.svg": 1084,
	"./seat-icons/broken-seat-2.svg": 1085,
	"./select-food.png": 708,
	"./settings.svg": 1086,
	"./show-password.svg": 357,
	"./slider-triangle.svg": 1087,
	"./snack.svg": 709,
	"./sort.svg": 1088,
	"./star-empty.svg": 1089,
	"./star-fill.svg": 1090,
	"./statistics.svg": 1091,
	"./success-tick.svg": 1092,
	"./suitcase.svg": 1093,
	"./swap.svg": 1094,
	"./tick-green-item.svg": 710,
	"./tick-green.svg": 1095,
	"./ticket-icon.svg": 1096,
	"./trash.svg": 1097,
	"./unpaid-reservation.svg": 684,
	"./updown-white.svg": 1098,
	"./updown.svg": 1099,
	"./user-attribute.svg": 1100,
	"./user-attributes.svg": 1101,
	"./user-female.svg": 1102,
	"./user-male-white.svg": 1103,
	"./user-male.svg": 1104,
	"./user-profile.svg": 297,
	"./userProfile.png": 1105,
	"./veg-food-mark-white.png": 1106,
	"./veg-foog-mark-trans.png": 1107,
	"./view.png": 1108,
	"./view.svg": 1109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 935
// module chunks = 34